var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuHeartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.414,
    height: 22.243,
    viewBox: "0 0 23.414 22.243",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bulk_Heart",
    "data-name": "Iconly/Bulk/Heart",
    transform: "translate(-2.759 -4.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Heart",
    transform: "translate(2.759 4.139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34179",
    d: "M11.419,22.053a42.447,42.447,0,0,1-7.408-5.8A14.831,14.831,0,0,1,.463,10.624C-.869,6.48.681,1.744,5.01.338a7.355,7.355,0,0,1,6.68,1.184h0A7.365,7.365,0,0,1,18.37.338C22.7,1.744,24.259,6.48,22.927,10.624A14.832,14.832,0,0,1,19.4,16.249a42.833,42.833,0,0,1-7.408,5.8l-.291.19Z",
    transform: "translate(0.026 0)",
    fill: "#ff4557",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34178",
    d: "M11.72,22.243l-.275-.19a42.519,42.519,0,0,1-7.419-5.8A14.829,14.829,0,0,1,.457,10.624C-.864,6.48.686,1.743,5.015.337a7.371,7.371,0,0,1,6.705,1.2Z",
    transform: "translate(0 0)",
    fill: "#ff4557"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34180",
    d: "M2.611,4.682h0a.841.841,0,0,1-.606-.325.958.958,0,0,1-.2-.692h0A1.928,1.928,0,0,0,.646,1.8.922.922,0,0,1,.026.694.849.849,0,0,1,1.037.022.449.449,0,0,1,1.2.083,3.742,3.742,0,0,1,3.508,3.776a.945.945,0,0,1-.268.656A.829.829,0,0,1,2.611,4.682Z",
    transform: "translate(16.39 3.512)",
    fill: "#ff4557"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuHeartIcon);
export default __webpack_public_path__ + "static/media/menu_heartIcon.616520f8e8e2fe02b1457f60ffae7e2e.svg";
export { ForwardRef as ReactComponent };